import { Button, Icon, IconNames } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import styles from './styles.module.scss';

type ToolbarButtonProps = {
  /** Icon to display in button */
  icon: IconNames;
  /** Should the button be disabled */
  disabled: boolean;
  /** Should the button be rendered in an an active state */
  active: boolean;
  /** Function to call when button is clicked */
  onClick?: () => void;
  /** Optional text to be displayed in the button */
  children?: string;
};

/** Renders a single button in the bulleten editor toolbar */
export function ToolbarButton({
  icon,
  disabled,
  active,
  onClick,
  children,
}: ToolbarButtonProps): JSX.Element {
  return (
    <Button
      className={styles.toolbarButton}
      disabled={disabled}
      variant={active ? 'primary' : 'secondary'}
      onMouseDown={(e) => {
        // So the editor doesn't loose focus
        e.preventDefault();
        onClick && onClick();
      }}
    >
      <Icon
        className={classnames({
          [styles.toolbarIconMargin]: !!children,
        })}
        name={icon}
      />
      {children}
    </Button>
  );
}
